import { useLanguage } from "@/i18n/LanguageContext";

export default function MidPageCta() {
  const { t } = useLanguage();
  return (
    <div className="bg-accent rounded-xl py-10 md:py-12 px-6 md:px-8 my-10 text-center">
      <h2 className="text-xl md:text-2xl font-bold text-white mb-3">
        {t("reviews.ctaTitle")}
      </h2>
      <p className="text-white/90 text-sm md:text-base mb-6">
        {t("reviews.ctaSub")}
      </p>
      <a
        href="tel:+17863774452"
        className="inline-flex items-center gap-2 bg-white text-accent px-8 py-3 text-sm font-bold rounded-lg hover:bg-white/90 transition-colors whitespace-nowrap"
      >
        <i className="ri-phone-line" />
        {t("hood.callNow")}
      </a>
    </div>
  );
}